import React, { useState, useCallback, useEffect } from 'react';
import { TextField } from '@shopify/polaris';

export function PercentageFieldCustom(props) {

    const format = function (val) {
        if (val === null) {
            val = "";
        }

        let newValue = val?.toString();
        if (!newValue) {
            return newValue;
        }

        let newValueInt = parseInt(newValue);
        if (newValueInt < 0) {
            newValueInt = 0;
        }
        else if (newValueInt > 100) {
            newValueInt = 100;
        }

        return newValueInt.toString();
    }

    const [value, setValue] = useState(format(props.value));

    const handleValueChange = useCallback(
        (newValue) => {
            const re = /^[0-9\b]+$/;
            if (newValue === '' || re.test(newValue)) {
                setValue(newValue);
                props.handleChange(props.fieldName, newValue);
            }
        },
        [props],
    );

    const handleBlur = useCallback(
        () => {
            let newValue = format(value);

            props.handleError(props.fieldName, props.required && (!newValue || parseInt(newValue) === 0));

            setValue(newValue);
            props.handleChange(props.fieldName, newValue);
        },
        [value, props],
    );

    useEffect(() => {
        setValue(format(props.value));
        // eslint-disable-next-line
    }, [props.fieldName]);

    return (
        <TextField
            id={props.id}
            value={value}
            label={props.label}
            helpText={props.helpText}
            suffix="%"
            error={props.error}
            onChange={(newValue) => handleValueChange(newValue)}
            onBlur={() => handleBlur()}
        />
    );
}